import { registerGetPageInfoFromRouter, register } from '@tencent/wuji-data-web';
import getXyHeaders, { getPageInfoFromRouter } from '@/utils/getXyHeaders';
import { $t } from '@/i18n';
import getXyManagePathPrefix from '@/utils/getXyManagePathPrefix';
registerGetPageInfoFromRouter(getPageInfoFromRouter);
register('getReqHeaders', getXyHeaders);
register('i18n', $t);
register('getReqPathPrefix', getXyManagePathPrefix);
export { createWujiData, getTypeDefinitions, getRuntimeConfigList } from '@tencent/wuji-data-web';
